import React, { memo } from 'react';
import style from "./index.module.scss";
import classNames from 'classnames';
/**
 * 付费标识组件
 */
const PayBadge = props => {
  const {
    className,
    type = 'mid',
    border = false
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, style['pay-badge-main'], style[`badge-${type}`], border ? style[`badge-${type}-border`] : '')
  });
};
PayBadge.displayName = 'cc-pay-badge';
export default /*#__PURE__*/memo(PayBadge);